'use client';
import * as React from 'react';
import { BlocksRenderer } from '../ui/blocks-renderer';
import {
  DynamicPageEventKeys,
  DynamicPageEvents,
} from 'src/components/containers/dynamic-page/events';
import { EventBus } from '@/shared/utils';
import { useSubscription } from '../hooks/use-subscription';
import { Auth } from 'firebase/auth';

interface ProfileScreenProps {
  data: any;
  eventBus: EventBus<DynamicPageEvents>;
  auth: Auth;
}

const PageScreen: React.FC<ProfileScreenProps> = ({ data, eventBus, auth }) => {
  const { getSubs } = useSubscription(auth);

  React.useEffect(() => {
    eventBus.on(DynamicPageEventKeys.subscription.list, getSubs);

    return () => {
      eventBus.off(DynamicPageEventKeys.subscription.list, getSubs);
    };
  }, [eventBus]);
  return <BlocksRenderer content={data.blocks} eventBus={eventBus} />;
};

export default PageScreen;
